import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import Loading from "../../Loading";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

class BPContestFileCreateAGB extends Component{


    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:null,
            bankCode:'',
            contestId: null,
            contestName:'',
            contestStatus:'',
            phaseId: null,
            phaseName:'',
            title:'',
            type:'SUMMARY',
            resultFlag: '0',
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
            selectedFile: null,
            isSelectedFile: false,
            show: false,
        }
        this.loadData = this.loadData.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleResultFlagChange = this.handleResultFlagChange.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    componentDidMount() {
        this.loadData( this.props?.contestId, this.props?.phaseId);
    }

    loadData(contestId, phaseId) {
        const {item} = this.state;
        const responseContest = axios.get('/api/bankportal/contest/'+contestId+'/load')
        const responsePhase = axios.get('/api/bankportal/contest/phase/'+phaseId+'/load')
        this.setState({isLoading: true})
        Promise.all([responseContest, responsePhase])
            .then(values => {
                const contest = values[0]?.data;
                const phase = values[1]?.data;
                item.bankCode = contest?.bankCode;
                item.contestId = contest?.id;
                item.contestName = contest?.name;
                item.contestStatus = contest?.status;
                item.phaseId = phase?.id;
                item.phaseName = phase?.name;
                this.setState({item: item, isLoading: false})
            })
            .catch(error =>{
                console.error('Error on loading data!',error)
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false})
            })
    }

    onFileChange(e) {
        this.setState({ selectedFile: e.target.files[0], isSelectedFile: true });
    };

    handleSubmit(){
        const {item, selectedFile, isSelectedFile} = this.state
        if(item?.title === ''){
            this.setState({errorMessage:'Tên tiêu đề không được rỗng'});
            return;
        }
        if(!isSelectedFile){
            this.setState({errorMessage:'Vui lòng chọn tập tin báo cáo dùng để upload!'});
            return;
        }
        const fileName = selectedFile?.name;
        const fileExtension = fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
        if(fileExtension.toUpperCase() !== 'XLSX'){
            this.setState({errorMessage:'Vui lòng chọn tập tin XLSX khi tải Memo'});
            return;
        }
        this.setState({errorMessage:''});
        const formData = new FormData();
        formData.append("contestId", item?.contestId);
        formData.append("contestPhaseId", item?.phaseId);
        formData.append("type", item?.type);
        formData.append("title", item?.title);
        formData.append("resultFlag", item?.resultFlag);
        formData.append("bankCode", item?.bankCode);
        this.setState({isLoading: true});
        axios.post('/api/bankportal/contest/phase/file/save', formData)
        .then(response =>{
            item.id = response?.data?.id;
            this.setState({item: item});
            const formUpload = new FormData();
            formUpload.append("file",selectedFile);
            const apiUpload = '/api/bankportal/contest/phase/file/'+response.data?.id+'/upload';
            return axios.post(apiUpload, formUpload);
        })
        .then(res =>{
            if(res.data !== null){
                console.log('Upload success:'+res);
                this.setState({successMessage: 'Tải báo cáo thành công',errorMessage:'', isLoading: false});
            }else{
                this.setState({successMessage: '',errorMessage:'Upload File thất bại', isLoading: false});
            }
        })
        .catch(error => {
            console.log(error?.response);
            this.setState({errorMessage: error?.message,successMessage:'', isLoading: false})
        })
    }
    handleTypeChange =(e) =>{
        const {item} = this.state;
        item.type = e.target.value;
        this.setState({item});
    }
    handleResultFlagChange =(e) =>{
        const {item} = this.state;
        item.resultFlag = e.target.value;
        this.setState({item});
    }
    handleTitleChange =(e) =>{
        const {item} = this.state;
        item.title = e.target.value;
        this.setState({item});
    }

    handleClose = (e) => this.setState({show: false});
    handleShow = (e) => {
        this.setState({show: true})
    };

    render() {
        const {item, isLoading,errorMessage, successMessage, show} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">TẢI TẬP TIN BÁO CÁO</h2>
                        <form>
                            <input type="hidden" value={item?.id} />
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng :</label>
                                <div className="col-sm-9">
                                    {item?.bankCode === 'VCB' && <span>Vietcombank</span>}
                                    {item?.bankCode === 'AGB' && <span>Agribank</span>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="contestName">Tên thi đua :</label>
                                <div className="col-sm-9">
                                    <span>{item?.contestName}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="phaseName">Tên đợt :</label>
                                <div className="col-sm-9">
                                    <span>{item?.phaseName}</span>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="type">Loại báo cáo :</label>
                                <div className="col-sm-9">
                                    <select id="type" className="form-control w-50" value={item?.type} onChange={this.handleTypeChange}>
                                        <option value="SUMMARY">Tổng</option>
                                        <option value="DETAIL">Chi tiết</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="resultFlag">Kết quả cuối cùng :</label>
                                <div className="col-sm-9">
                                    <select id="resultFlag" className="form-control w-50" value={item?.resultFlag} onChange={this.handleResultFlagChange}>
                                        <option value="0">Tạm tính</option>
                                        <option value="1">Kết quả</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="title">Tiêu đề báo cáo :</label>
                                <div className="col-sm-9">
                                    <input type={'text'} onChange={this.handleTitleChange} className={'form-control'} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3">Chọn báo cáo để tải lên :</label>
                                <div className="col-sm-9">
                                    <input type="file" className={'form-control-file'} onChange={this.onFileChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3">Xem hướng dẫn:</label>
                                <div className="col-sm-9">
                                    <span className='btn btn-outline-info' onClick={ this.handleShow }>
                                        Hướng dẫn upload tập tin
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/contest/phase/'+item?.phaseId+'/detail'} className="btn btn-success">Quay về</Link>
                                    {item?.contestStatus !== 'COMPLETED' && !item?.id && <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">Thực hiện tải báo cáo</button> }
                                </div>
                            </div>
                        </form>
                        <Modal isOpen={show} toggle={() => this.handleClose}>
                            <ModalHeader>
                                Áp dụng cho ngân hàng Agribank
                            </ModalHeader>
                            <ModalBody>
                                <p>Chỉ hỗ trợ file EXCEL (.XLSX)</p>
                                <p>Định dạng nội dung cột: TEXT</p>
                                <p>File upload hỗ trợ tối đa 20MB</p>
                                <p>Thứ tự các cột trong file EXCEL :</p>
                                <ul>
                                    <li>Cột 1: Mã banker</li>
                                    <li>Cột 2: Tên banker</li>
                                    <li>Cột 3: Mã TO</li>
                                    <li>Cột 4: Tên TO</li>
                                    <li>Cột 5: Mã BO2</li>
                                    <li>Cột 6: Tên BO2</li>
                                    <li>Cột 7: Mã BO1</li>
                                    <li>Cột 8: Tên BO1</li>
                                </ul>
                            </ModalBody>
                            <ModalFooter>
                                <button type="button" className="btn btn-secondary" onClick={this.handleClose}>Đóng hướng dẫn</button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}
export default BPContestFileCreateAGB;